var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"800","scrollable":""},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[(_vm.show)?_c('kus-document-preview-card',{attrs:{"file":_vm.file},on:{"close":function($event){_vm.show = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }